<!--  -->
<template>
  <div class="meter">
    <div :class="[meterLevel[nowLevel], 'box']">
      <div
        :class="['progress', nowLevel > index - 1 ? 'active' : '']"
        v-for="(item, index) in meterText"
        :key="item"
      ></div>
      <p>{{ meterText[nowLevel] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowLevel: "",
      meterLevel: ["one", "two", "three", "four"],
      meterText: ["弱", "中", "强", "很强"],
    };
  },
  props: ["password"],
  watch: {
    password(newVal) {
      const val = newVal;
      this.nowLevel = this.checkRules(val);
    },
  },
  created() {},
  mounted() {},
  methods: {
    checkRules(val) {
      let modes = 0;
      if (val.length == 0) return "";
      if (val.length < 6) return 0;
      if (/\d/.test(val)) modes = 0; //数字
      if (/[a-z]/.test(val)) modes++; //小写
      if (/[A-Z]/.test(val)) modes++; //大写
      if (/\W/.test(val)) modes++; //特殊字符
      if (val.length > 12) return 3;
      return modes;
    },
  },
};
</script>

<style lang='scss' scoped>
.meter {
  line-height: 1;
  font-size: 12px;
}

.box {
  height: 15px;
  display: flex;
  align-items: center;

  .progress {
    width: 50px;
    height: 5px;
    border-radius: 5px;
    color: white;
    background: grey;
    margin-right: 2px;
    text-align: center;
  }

  p {
    margin-left: 5px;
  }
}

.one .active {
  background-color: #f56c6c;
}
.two .active {
  background-color: #e6a23c;
}
.three .active {
  background-color: #d1ce17;
}
.four .active {
  background-color: #67c23a;
}
</style>
